import { defineStore } from "pinia";

export enum ModalType {
  New = "new",
  Login = "login",
  SaveAs = "saveAs",
  SaveDesign = "saveDesign",
  Load = "load",
  MyDesigns = "myDesigns",
  File = "file",
  GridSize = "gridSize",
  MyTiles = "myTiles",
  Share = "share",
  AttachmentOption = "attachmentOption",
  ColorRemap = "colorRemap",
}

interface ModalState {
  visible: boolean;
  callback: Function | null;
  options: any;
}

export const useModalStore = defineStore("modalStore", {
  state: () => ({
    modals: {
      [ModalType.New]: { visible: false, callback: null, options: null },
      [ModalType.Login]: { visible: false, callback: null, options: null },
      [ModalType.SaveAs]: { visible: false, callback: null, options: null },
      [ModalType.SaveDesign]: { visible: false, callback: null, options: null },
      [ModalType.Load]: { visible: false, callback: null, options: null },
      [ModalType.MyDesigns]: { visible: false, callback: null, options: null },
      [ModalType.File]: { visible: false, callback: null, options: null },
      [ModalType.GridSize]: { visible: false, callback: null, options: null },
      [ModalType.MyTiles]: { visible: false, callback: null, options: null },
      [ModalType.Share]: { visible: false, callback: null, options: null },
      [ModalType.AttachmentOption]: {
        visible: false,
        callback: null,
        options: null,
      },
      [ModalType.ColorRemap]: {
        visible: false,
        callback: null,
        options: null,
      },
    } as Record<ModalType, ModalState>,
  }),
  getters: {
    isAnyVisible: (state) =>
      Object.values(state.modals).some((modal) => modal.visible === true),
    getModalOptions: (state) => (type: ModalType) => state.modals[type].options,
    getModalCallback: (state) => (type: ModalType) =>
      state.modals[type].callback,
  },
  actions: {
    toggleModal(
      type: ModalType,
      payload?: { callback?: Function; options?: any },
    ) {
      const modal = this.modals[type];
      const isClosing = modal.visible;

      this.modals[type] = {
        visible: !modal.visible,
        callback: isClosing ? null : payload?.callback || null,
        options: isClosing ? null : payload?.options || null,
      };
    },

    handleSuccess(type: ModalType) {
      const modal = this.modals[type];
      if (modal.callback) {
        modal.callback();
        modal.callback = null;
        modal.options = null;
      }
      this.toggleModal(type);
    },
  },
});
